import Vue from 'vue'
import store from './store'
import App from './App.vue'

 import sdkComponents from 'hy-rtc-sdk-components'
 import 'hy-rtc-sdk-components/lib/hy-rtc-sdk-components.css'
Vue.use(sdkComponents, { sdkParams: {version: '0.2.0', serviceVersion: '0.3.0'}});

new Vue({
  el: '#app',
   store,
  render: h => h(App),
}).$mount('#app')
